<template>
  <button type="button" class="btn btn-dark" v-on:click="$gAuth.signIn">Login</button>
</template>

<script>
export default {};
</script>